<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div><router-link to="/Admin/withdrawal/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>
                    <!-- <div><el-input v-model="name" placeholder="请输入内容"></el-input></div>
                    <div><el-button icon="el-icon-search">条件筛选</el-button></div> -->
                </div>

               <!-- <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div> -->
            </div>

            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column>
                    <!-- <el-table-column prop="withdraw_coins" label="提现金币数"></el-table-column> -->
                    <el-table-column prop="price" label="提现金额"></el-table-column>
					<el-table-column prop="audit" label="审核类型">
					    <template slot-scope="scope">
							<el-tag type="success" v-if="scope.row.audit ==1">免审核</el-tag>
							<el-tag type="warning" v-if="scope.row.audit ==2">需审核</el-tag>
					    </template>
					</el-table-column>
					<el-table-column prop="number" label="提现次数"></el-table-column>
					<el-table-column prop="mode" label="模式">
					    <template slot-scope="scope">
							<el-tag type="info" v-if="scope.row.mode ==1">每天</el-tag>
							<el-tag type="info" v-if="scope.row.mode ==2">总数</el-tag>
					    </template>
					</el-table-column>
                    <el-table-column prop="add_time" label="创建时间"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="220px">
                        <template slot-scope="scope">
							<el-button icon="el-icon-edit" @click="$router.push({name:'store_withdrawal_form',params:scope.row})">编辑</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          select_id:'',
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleSelectionChange:function(e){
            let ids = [];
            e.forEach(v => {
                ids.push(v.id);
            });
            this.select_id = ids.join(',');
        },
        get_cash_list:function(){
            let _this = this;
            this.$get(this.$api.withdrawalList,{page:this.current_page}).then(function(res){
                _this.page_size = res.data.per_page;
                _this.total_data = res.data.total;
                _this.current_page = res.data.current_page;
                _this.list = res.data.data;
            })

        },
        // 分页改变
        current_change:function(e){
            this.current_page = e;
            this.get_cash_list();
        },
        // 删除处理
        del:function(id){
            let _this = this;
            if(this.$isEmpty(id)){
                return this.$message.error('请先选择删除的对象');
            }
            this.$post(this.$api.withdrawalDel,{id:id}).then(function(res){
                if(res.code == 200){
                    _this.get_cash_list();
                    return _this.$message.success("删除成功");
                }else{
                    return _this.$message.error("删除失败");
                }
            });
        },
    },
    created() {
        this.get_cash_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>